import identity from 'ramda/src/identity'
import createProjectDrop from 'root/src/client/logic/project/thunks/createProjectDrop'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { CHECK_USER_HAS_GAME } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { getUserDropEventLandingShortUrl } from 'root/src/client/logic/dropEvent/thunks/getUserDropEventLandingShortUrl'
import { modalContextImperative } from 'root/src/client/v2/common/contexts/modal.context'
import { KeySelectionModal } from 'root/src/client/v2/drop/features/KeySelectionModal/components/KeySelectionModal'
import { InitialProductDisplayModal } from 'root/src/client/v2/drop/features/KeySelectionModal/components/InitialProductDisplayModal'

export default formData => async (dispatch, getState) => {
	const { dropEvent, dare } = formData
	const { id: campaignId, initialProduct, brand: { id: brandId }, isGameFree } = dropEvent
	const { body: userHasKey } = await dispatch(
		apiRequest(CHECK_USER_HAS_GAME, { brandId, campaignId }),
	)
	if (!userHasKey) {
		if (initialProduct?.length) {
			return modalContextImperative.show(<KeySelectionModal dropEvent={dropEvent} payload={formData} dare={dare} />)
		}
	}

	const showModalFn = async () => {
		if (userHasKey && (isGameFree || !initialProduct)) {
			const shortUrl = await getUserDropEventLandingShortUrl(dropEvent.id)(dispatch, getState)
			return modalContextImperative.show(
				<InitialProductDisplayModal dropEvent={dropEvent} dare={dare} shortUrl={shortUrl} />, {
					isCloseable: false,
				},
			)
		}

		return identity
	}

	return dispatch(createProjectDrop(formData, showModalFn))
}
